// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import CreateShopArticleTaxHistoryRequestModel from '../../model/create-shop-article-tax-history-request-model';
import CreateShopArticleTaxHistoryRequestDTO from '../dto/create-shop-article-tax-history-request-dto';
import dtoSchema from '../schemas/create-shop-article-tax-history-request-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class CreateShopArticleTaxHistoryRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<CreateShopArticleTaxHistoryRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.shopArticleTaxId = data.shopArticleTaxId;
      this.taxRate = data.taxRate;
      this.validFrom = data.validFrom;
      this.validTo = data.validTo ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  shopArticleTaxId?: number;
  /**
  * @type {double}
  */
  taxRate?: number;
  /**
  * @type {date-time}
  */
  validFrom?: string;
  /**
  * @type {date-time}
  */
  validTo?: string;

  static toModel(dto: DeepPartial<CreateShopArticleTaxHistoryRequestDTO>): CreateShopArticleTaxHistoryRequestModel;
  static toModel(dto: DeepPartial<CreateShopArticleTaxHistoryRequestDTO> | undefined | null): CreateShopArticleTaxHistoryRequestModel | undefined;
  static toModel(dto: DeepPartial<CreateShopArticleTaxHistoryRequestDTO> | undefined | null): CreateShopArticleTaxHistoryRequestModel | undefined {
    return dto ? new CreateShopArticleTaxHistoryRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<CreateShopArticleTaxHistoryRequestModel> | CreateShopArticleTaxHistoryRequestModel): CreateShopArticleTaxHistoryRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      shopArticleTaxId: unwrapped.shopArticleTaxId,
      taxRate: unwrapped.taxRate,
      validFrom: unwrapped.validFrom,
      validTo: unwrapped.validTo,
    } as CreateShopArticleTaxHistoryRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for CreateShopArticleTaxHistoryRequestModel, can not map to CreateShopArticleTaxHistoryRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
